export const getInitialState = (): any => ({
  undeployData: {},
  undeployStatus: 0
});
